import { LayaGL } from "../../../../layagl/LayaGL";
import { Color } from "../../../../maths/Color";
import { Matrix } from "../../../../maths/Matrix";
import { Vector3 } from "../../../../maths/Vector3";
import { Vector4 } from "../../../../maths/Vector4";
import { BaseRenderNode2D } from "../../../../NodeRender2D/BaseRenderNode2D";
import { DrawType } from "../../../../RenderEngine/RenderEnum/DrawType";
import { IndexFormat } from "../../../../RenderEngine/RenderEnum/IndexFormat";
import { MeshTopology } from "../../../../RenderEngine/RenderEnum/RenderPologyMode";
import { Texture2D } from "../../../../resource/Texture2D";
import { SpineShaderInit } from "../../../../spine/shader/SpineShaderInit";
import { ShaderDefines2D } from "../../../../webgl/shader/d2/ShaderDefines2D";
export class WebRender2DDataHandle {
    get owner() {
        return this._owner;
    }
    set owner(value) {
        this._owner = value;
    }
    constructor() {
        this._nMatrix_0 = new Vector3();
        this._nMatrix_1 = new Vector3();
        this._needUseMatrix = true;
    }
    get needUseMatrix() {
        return this._needUseMatrix;
    }
    set needUseMatrix(value) {
        this._needUseMatrix = value;
        if (!value) {
            this._nMatrix_0.set(1, 0, 0);
            this._nMatrix_1.set(0, 1, 0);
            this._owner.spriteShaderData.setVector3(ShaderDefines2D.UNIFORM_NMATRIX_0, this._nMatrix_0);
            this._owner.spriteShaderData.setVector3(ShaderDefines2D.UNIFORM_NMATRIX_1, this._nMatrix_1);
        }
    }
    destroy() {
    }
    inheriteRenderData(context) {
        let data = this._owner.spriteShaderData;
        if (!data)
            return;
        if (this._needUseMatrix) {
            let mat = this._owner.renderMatrix;
            this._nMatrix_0.setValue(mat.a, mat.c, mat.tx);
            this._nMatrix_1.setValue(mat.b, mat.d, mat.ty);
            this._owner.spriteShaderData.setVector3(ShaderDefines2D.UNIFORM_NMATRIX_0, this._nMatrix_0);
            this._owner.spriteShaderData.setVector3(ShaderDefines2D.UNIFORM_NMATRIX_1, this._nMatrix_1);
        }
    }
}
export class WebEmptyRender2DDataHandle extends WebRender2DDataHandle {
    inheriteRenderData(_context) {
    }
    destroy() {
    }
}
export class WebGraphics2DBufferBlock {
}
export class WebGraphics2DVertexBlock {
}
export class WebPrimitiveDataHandle extends WebRender2DDataHandle {
    constructor() {
        super(...arguments);
        this.logicMatrix = null;
        this.mask = null;
        this._bufferBlocks = null;
        this._modifiedFrame = -1;
        this._globalAlpha = 1;
    }
    applyVertexBufferBlock(blocks) {
        this._bufferBlocks = blocks;
        this.updateCloneView();
        this._globalAlpha = this._owner.globalAlpha;
        if (this._owner.trans) {
            this._modifiedFrame = this._owner.trans.modifiedFrame;
        }
    }
    skipBufferUpdate() {
        if (this._owner.trans) {
            this._modifiedFrame = this._owner.trans.modifiedFrame;
        }
    }
    _getBlocks() {
        return this._bufferBlocks;
    }
    inheriteRenderData(context) {
        let data = this._owner.spriteShaderData;
        if (!data)
            return;
        let trans = this._owner.trans;
        let mat = trans.matrix;
        if (this._modifiedFrame < trans.modifiedFrame) {
            if (!this._bufferBlocks || !this._bufferBlocks.length) {
                if (this.logicMatrix) {
                    let temp = Matrix.TEMP;
                    Matrix.mul(this.logicMatrix, mat.copyTo(temp), temp);
                    this._nMatrix_0.setValue(temp.a, temp.c, temp.tx);
                    this._nMatrix_1.setValue(temp.b, temp.d, temp.ty);
                }
                else {
                    this._nMatrix_0.setValue(mat.a, mat.c, mat.tx);
                    this._nMatrix_1.setValue(mat.b, mat.d, mat.ty);
                }
                this._owner.spriteShaderData.setVector3(ShaderDefines2D.UNIFORM_NMATRIX_0, this._nMatrix_0);
                this._owner.spriteShaderData.setVector3(ShaderDefines2D.UNIFORM_NMATRIX_1, this._nMatrix_1);
            }
            else {
                this._updateVertexData(mat, this._owner.globalAlpha, true, true, false);
                this._globalAlpha = this._owner.globalAlpha;
            }
            this._modifiedFrame = trans.modifiedFrame;
        }
        else if (this._globalAlpha != this._owner.globalAlpha) {
            this._globalAlpha = this._owner.globalAlpha;
            if (this._bufferBlocks && this._bufferBlocks.length)
                this._updateVertexData(mat, this._owner.globalAlpha, false, true, false);
        }
    }
    _updateVertexData(mat, globalAlpha, updateMatrix, updateGlobalAlpha, updateTextureArrayLayerIndex) {
        let pos = 0, dataViewIndex = 0, ci = 0;
        let dataView = null;
        let m00 = 1, m01 = 0, m10 = 0, m11 = 1, tx = 0, ty = 0;
        if (updateMatrix) {
            m00 = mat.a, m01 = mat.b, m10 = mat.c, m11 = mat.d, tx = mat.tx, ty = mat.ty;
        }
        let vbdata = null;
        let vertexCount = 0, positions = null, vertexViews = null;
        let stride = this._bufferBlocks[0].vertexBuffer.vertexDeclaration.vertexStride / 4;
        let textureArrayLayerIndex = 0;
        for (let i = 0, n = this._bufferBlocks.length; i < n; i++) {
            let vertexs = this._bufferBlocks[i].vertexs;
            textureArrayLayerIndex = this._bufferBlocks[i].textureArrayIndex;
            for (let index = 0, len = vertexs.length; index < len; index++) {
                positions = vertexs[index].positions;
                vertexViews = vertexs[index].vertexViews;
                vertexCount = positions.length / 2;
                dataView = null;
                pos = 0, ci = 0, dataViewIndex = 0;
                for (let j = 0; j < vertexCount; j++) {
                    if (!dataView || dataView.length <= pos) {
                        dataView = vertexViews[dataViewIndex];
                        dataView._modify();
                        dataViewIndex++;
                        pos = 0;
                        vbdata = dataView._getData();
                    }
                    if (updateMatrix) {
                        let x = positions[ci], y = positions[ci + 1];
                        vbdata[pos] = x * m00 + y * m10 + tx;
                        vbdata[pos + 1] = x * m01 + y * m11 + ty;
                    }
                    if (updateGlobalAlpha) {
                        vbdata[pos + 10] = globalAlpha;
                    }
                    if (updateTextureArrayLayerIndex) {
                        vbdata[pos + 11] = textureArrayLayerIndex;
                    }
                    pos += stride;
                    ci += 2;
                }
            }
        }
    }
    getCloneViews() {
        if (!this._clonesViews) {
            this._clonesViews = [];
            for (let i = 0, n = this._bufferBlocks.length; i < n; i++) {
                this._clonesViews[i] = this._cloneView(this._bufferBlocks[i].indexView);
            }
        }
        return this._clonesViews;
    }
    updateCloneView() {
        let cloneViews = this.getCloneViews();
        let blockLength = this._bufferBlocks.length;
        let cloneLength = cloneViews.length;
        if (cloneLength > blockLength) {
            for (let i = blockLength; i < cloneLength; i++) {
                let view = cloneViews[i];
                view._geometry.destroy();
                if (view.owner)
                    view.owner.removeDataView(view);
            }
        }
        this._clonesViews.length = blockLength;
        for (let i = 0; i < blockLength; i++) {
            let view = cloneViews[i];
            let block = this._bufferBlocks[i];
            if (block) {
                cloneViews[i] = this._cloneView(block.indexView, view);
            }
        }
    }
    _cloneView(view, oView = null) {
        let clone;
        if (oView && oView._geometry) {
            clone = oView;
            view._cloneView(clone);
        }
        else {
            clone = view._clone(false, false);
            clone._geometry = LayaGL.renderDeviceFactory.createRenderGeometryElement(MeshTopology.Triangles, DrawType.DrawElement);
            clone._geometry.indexFormat = IndexFormat.UInt16;
        }
        return clone;
    }
    destroy() {
        super.destroy();
        if (this._clonesViews) {
            for (let i = 0, n = this._clonesViews.length; i < n; i++)
                this._clonesViews[i]._geometry.destroy();
            this._clonesViews = null;
        }
        this._bufferBlocks = null;
    }
}
export class Web2DBaseRenderDataHandle extends WebRender2DDataHandle {
    constructor() {
        super(...arguments);
        this._lightReceive = false;
    }
    get lightReceive() {
        return this._lightReceive;
    }
    set lightReceive(value) {
        this._lightReceive = value;
        if (value) {
            this._owner.spriteShaderData.addDefine(BaseRenderNode2D.SHADERDEFINE_LIGHT2D_ENABLE);
        }
        else {
            this._owner.spriteShaderData.removeDefine(BaseRenderNode2D.SHADERDEFINE_LIGHT2D_ENABLE);
        }
    }
    get owner() {
        return this._owner;
    }
    set owner(value) {
        if (value == this.owner)
            return;
        if (this._owner) {
            this._owner.spriteShaderData.removeDefine(BaseRenderNode2D.SHADERDEFINE_BASERENDER2D);
        }
        this._owner = value;
        if (this._owner) {
            this._owner.spriteShaderData.addDefine(BaseRenderNode2D.SHADERDEFINE_BASERENDER2D);
        }
    }
}
const _setRenderColor = new Color(1, 1, 1, 1);
export class WebMesh2DRenderDataHandle extends Web2DBaseRenderDataHandle {
    constructor() {
        super(...arguments);
        this._baseColor = new Color(1, 1, 1, 1);
        this._tilingOffset = new Vector4();
        this._renderAlpha = -1;
    }
    get baseColor() {
        return this._baseColor;
    }
    set baseColor(value) {
        if (value != this._baseColor && this._baseColor.equal(value))
            return;
        value = value ? value : Color.BLACK;
        value.cloneTo(this._baseColor);
        this._renderAlpha = -1;
        this._owner.spriteShaderData.setColor(BaseRenderNode2D.BASERENDER2DCOLOR, this._baseColor);
    }
    get baseTexture() {
        return this._baseTexture;
    }
    set baseTexture(value) {
        if (this._baseTexture != null && value == this._baseTexture)
            return;
        if (this._baseTexture)
            this._baseTexture._removeReference();
        this._baseTexture = value;
        value = value ? value : Texture2D.whiteTexture;
        this._owner.spriteShaderData.setTexture(BaseRenderNode2D.BASERENDER2DTEXTURE, value);
        if (value) {
            value._addReference();
            if (value.gammaCorrection != 1) {
                this._owner.spriteShaderData.addDefine(ShaderDefines2D.GAMMATEXTURE);
            }
            else {
                this._owner.spriteShaderData.removeDefine(ShaderDefines2D.GAMMATEXTURE);
            }
        }
    }
    get tilingOffset() {
        return this._tilingOffset;
    }
    set tilingOffset(value) {
        if (!value)
            return;
        this._owner.spriteShaderData.setVector(BaseRenderNode2D.TILINGOFFSET, value);
        value ? value.cloneTo(this._tilingOffset) : null;
    }
    get normal2DTexture() {
        return this._normal2DTexture;
    }
    set normal2DTexture(value) {
        if (value === this._normal2DTexture)
            return;
        if (this._normal2DTexture)
            this._normal2DTexture._removeReference(1);
        if (value)
            value._addReference();
        this._normal2DTexture = value;
        this._owner.spriteShaderData.setTexture(BaseRenderNode2D.NORMAL2DTEXTURE, value);
        if (this._normal2DStrength > 0 && this._normal2DTexture)
            this._owner.spriteShaderData.addDefine(BaseRenderNode2D.SHADERDEFINE_LIGHT2D_NORMAL_PARAM);
        else
            this._owner.spriteShaderData.removeDefine(BaseRenderNode2D.SHADERDEFINE_LIGHT2D_NORMAL_PARAM);
    }
    get normal2DStrength() {
        return this._normal2DStrength;
    }
    set normal2DStrength(value) {
        value = Math.max(0, Math.min(1, value));
        if (this._normal2DStrength === value)
            return;
        this._normal2DStrength = value;
        this._owner.spriteShaderData.setNumber(BaseRenderNode2D.NORMAL2DSTRENGTH, value);
        if (value > 0 && this._normal2DTexture)
            this._owner.spriteShaderData.addDefine(BaseRenderNode2D.SHADERDEFINE_LIGHT2D_NORMAL_PARAM);
        else
            this._owner.spriteShaderData.removeDefine(BaseRenderNode2D.SHADERDEFINE_LIGHT2D_NORMAL_PARAM);
    }
    inheriteRenderData(context) {
        super.inheriteRenderData(context);
        if (this._renderAlpha != this._owner.globalAlpha) {
            let a = this._owner.globalAlpha * this._baseColor.a;
            _setRenderColor.setValue(this._baseColor.r, this._baseColor.g, this._baseColor.b, a);
            this._owner.spriteShaderData.setColor(BaseRenderNode2D.BASERENDER2DCOLOR, _setRenderColor);
            this._renderAlpha = this._owner.globalAlpha;
        }
    }
}
export class WebSpineRenderDataHandle extends Web2DBaseRenderDataHandle {
    constructor() {
        super(...arguments);
        this._renderAlpha = -1;
        this._baseColor = new Color(1, 1, 1, 1);
        this.normalUpdater = null;
    }
    get baseColor() {
        return this._baseColor;
    }
    set baseColor(value) {
        if (value != this._baseColor && this._baseColor.equal(value))
            return;
        value = value ? value : Color.BLACK;
        value.cloneTo(this._baseColor);
        this._renderAlpha = -1;
        this._owner.spriteShaderData.setColor(BaseRenderNode2D.BASERENDER2DCOLOR, this._baseColor);
    }
    get owner() {
        return this._owner;
    }
    set owner(value) {
        if (value == this.owner)
            return;
        if (this._owner) {
            let shaderData = this._owner.spriteShaderData;
            shaderData.removeDefine(BaseRenderNode2D.SHADERDEFINE_BASERENDER2D);
            shaderData.removeDefine(SpineShaderInit.SPINE_UV);
            shaderData.removeDefine(SpineShaderInit.SPINE_COLOR);
        }
        this._owner = value;
        if (this._owner) {
            let shaderData = this._owner.spriteShaderData;
            shaderData.addDefine(BaseRenderNode2D.SHADERDEFINE_BASERENDER2D);
            shaderData.addDefine(SpineShaderInit.SPINE_UV);
            shaderData.addDefine(SpineShaderInit.SPINE_COLOR);
        }
    }
    get offset() {
        return this._offset;
    }
    set offset(value) {
        this._offset = value;
    }
    inheriteRenderData(context) {
        if (!this._owner || !this._owner.spriteShaderData || !this.skeleton)
            return;
        let shaderData = this.owner.spriteShaderData;
        let trans = this.owner.renderMatrix;
        let mat = trans;
        if (this._offset) {
            let ofx = this._offset.x;
            let ofy = this._offset.y;
            this._nMatrix_0.setValue(mat.a, mat.c, mat.tx + mat.a * ofx + mat.c * ofy);
            this._nMatrix_1.setValue(mat.b, mat.d, mat.ty + mat.b * ofx + mat.d * ofy);
        }
        else {
            this._nMatrix_0.setValue(mat.a, mat.c, mat.tx);
            this._nMatrix_1.setValue(mat.b, mat.d, mat.ty);
        }
        shaderData.setVector3(ShaderDefines2D.UNIFORM_NMATRIX_0, this._nMatrix_0);
        shaderData.setVector3(ShaderDefines2D.UNIFORM_NMATRIX_1, this._nMatrix_1);
        if (this._renderAlpha != this._owner.globalAlpha) {
            let a = this._owner.globalAlpha * this._baseColor.a;
            _setRenderColor.setValue(this._baseColor.r, this._baseColor.g, this._baseColor.b, a);
            this._owner.spriteShaderData.setColor(BaseRenderNode2D.BASERENDER2DCOLOR, _setRenderColor);
            this._renderAlpha = this._owner.globalAlpha;
        }
    }
}
